import { ThemeEvents } from '@theme/events';

// Carlyle Avenue — mobile chrome scroll choreography.
// One controller hides BOTH the header and the bottom tab bar together: on
// scroll down past the threshold it adds `ca-chrome-hidden` to <body> (CSS
// translates the header up and the tab bar down), and removes it on scroll up.
// rAF-throttled, passive.

// Keep the cart tab's accessible name (item count) current after add-to-cart. Its
// aria-label is server-rendered, so it goes stale; the wrapping <cart-icon> updates
// the visible badge and we mirror the new total into the aria-label on the next frame
// (after cart-icon.js has written the count). Event: 'cart:update' (@theme/events).
const cartTab = document.querySelector('[data-ca-cart-tab]');

if (cartTab) {
  document.addEventListener(ThemeEvents.cartUpdate, () => {
    requestAnimationFrame(() => {
      const countEl = cartTab.querySelector('[ref="cartBubbleCount"]');
      const count = parseInt((countEl && countEl.textContent) || '0', 10) || 0;
      const label = cartTab.dataset.cartLabel || 'Cart';
      const word = cartTab.dataset.cartCountWord || '';
      cartTab.setAttribute('aria-label', count > 0 ? `${label}, ${count} ${word}`.trim() : label);
    });
  });
}

const bar = document.querySelector('.ca-tabbar');
const header = document.getElementById('header-component');

// WCAG 2.4.7 / 2.1.1 — the header and tab bar are only ever *visually* hidden
// (CSS transform), never removed from the tab order. If a keyboard user Tabs
// into either while `ca-chrome-hidden` is set, both sit fully off-screen with
// no visible focus indicator anywhere on the page. Reveal the chrome the
// moment focus lands inside it, and keep it revealed for as long as focus
// stays there — the scroll handler below checks `chromeFocusLocked` so it
// doesn't immediately re-hide the chrome out from under the focused element
// (e.g. via a browser auto-scroll-into-view triggered by the Tab itself).
let chromeFocusLocked = false;
// Mirrors the class so the DOM is only touched on an actual change. Toggling a class on <body>
// invalidates style for the whole document, and the scroll handler ran it on nearly every frame.
let chromeHidden = false;

const setChromeHidden = (hidden) => {
  if (hidden === chromeHidden) return;
  chromeHidden = hidden;
  document.body.classList.toggle('ca-chrome-hidden', hidden);
};

const isInChrome = (node) => Boolean(node && ((header && header.contains(node)) || (bar && bar.contains(node))));

document.addEventListener('focusin', (event) => {
  if (!isInChrome(event.target)) return;
  chromeFocusLocked = true;
  setChromeHidden(false);
});

document.addEventListener('focusout', (event) => {
  if (!isInChrome(event.target)) return;
  // relatedTarget is the element about to receive focus (null for e.g. a
  // click landing outside any focusable element, or focus leaving the doc).
  if (!isInChrome(event.relatedTarget)) {
    chromeFocusLocked = false;
  }
});

if (bar) {
  let last = window.scrollY;
  let ticking = false;
  const THRESHOLD = 200; // don't hide until well down the page

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (Math.abs(y - last) > 6) {
          const goingDown = y > last && y > THRESHOLD;
          if (!(goingDown && chromeFocusLocked)) {
            setChromeHidden(goingDown);
          }
          last = y;
        }
        ticking = false;
      });
    },
    { passive: true }
  );
}
